import angular from 'angular';
import constants from 'app/constants';
import {
  ssDialogService,
} from 'app/services';
import controller from './assign-vendor-managers-dialog.controller';
import template from './assign-vendor-managers-dialog.html';


class dialogService {
  getOptions($event, { vendorId, vendorManagers, addCallback }) {
    return {
      controller,
      controllerAs: 'assignVendorManagersDialogVM',
      locals: {
        vendorId,
        vendorManagers,
        addCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.assignVendorManagersDialog', [
  constants,
  ssDialogService,
])
  .service('assignVendorManagersDialog', dialogService)
  .name;
